import $ from 'jquery';

import {Analytics} from "@plaudit/analytics";
Analytics.setup(); // This will set up the system and return an instance of Analytics.

function onCheckFormConfirmation() {
	const confirmations = document.querySelectorAll(".analyticsFormConfirmation");
	for (let i=0; i < confirmations.length; i++) {
		const confirmation = confirmations[i];
		if (confirmation !== undefined && confirmation instanceof HTMLElement) {
			// Remove so it is not processed again
			confirmation.remove();
			
			// Process it
			const formTitle = confirmation.dataset.analyticsFormTitle;
			const formId = confirmation.dataset.analyticsFormId;
			const formType = confirmation.dataset.analyticsFormType;
			const analytics = Analytics.getInstance();
			analytics.trackEvent(formType, "Confirmation", `${formTitle} (ID: ${formId})`);
		}
	}
}

$(document).on("gform_confirmation_loaded", onCheckFormConfirmation);
$(document).on("frmFormComplete", onCheckFormConfirmation);
$(document).on("ready", onCheckFormConfirmation);
